module.exports = __webpack_public_path__ + "static/music-tab-app-cover-2187743a41aee029227560a7498ceea4.png";